import { AxiosResponse } from 'axios'
import { HttpService } from './common/HttpService'
import { CustomerReview, CustomerReviewDetails, UpdateCustomerReviewResponse } from '@/models/dto/CustomerReview'
import { ApiResult } from '@/models/dto'

const httpService: HttpService = new HttpService()

export default {
  /**
   * Gets trip details and customer review details for a reservation and customer
   * @param reservationId - The ID of the reservation to get review details for
   * @param customerId - The ID of the customer to get review details for
   * @returns A promise that resolves to the customer review details
   */
  getCustomerReviewDetails(reservationId: string, customerId: string): Promise<AxiosResponse<CustomerReviewDetails>> {
    const url = `/reviews/${reservationId}/${customerId}`
    return httpService.get(url)
  },

  /**
   * Submits customer review for a reservation
   * @param payload - The customer review data
   * @returns A promise that resolves to the result of submitting the review
   */
  updateCustomerReview(payload: CustomerReview): Promise<AxiosResponse<UpdateCustomerReviewResponse>> {
    const url = `/reviews`
    return httpService.put(url, payload)
  }
}
